"use strict";

angular.module('rmToken', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');
